import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceHighlight.css';

function ServiceHighlight() {
  const services = [
    {
      icon: "🔥",
      title: "Fire Detection Systems",
      description: "Advanced fire alarm installation, smoke detectors, and 24/7 monitoring services."
    },
    {
      icon: "🛡️",
      title: "Fire Protection Equipment",
      description: "High-quality fire extinguishers, hose reels, and suppression systems."
    },
    {
      icon: "⚡",
      title: "Building Electrical Systems",
      description: "Comprehensive electrical solutions for modern buildings (Coming Soon)."
    },
    {
      icon: "📹",
      title: "Security Systems",
      description: "CCTV, access control, and complete alarm ecosystems (Coming Soon)."
    },
    {
      icon: "🧯",
      title: "Fire Gas Suppression Systems",
      description: "Clean agent fire suppression systems designed to protect critical assets."
    },
    {
      icon: "📢",
      title: "PUBLIC ADDRESS AND VOICE EVACUATION SYSTEMS",
      description: "Clear and reliable voice evacuation for safe and organized emergency response."
    }
  ];

  return (
    <section className="section services-overview">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Explore Our Services</h2>
          <p className="section-subtitle">Comprehensive safety provisions tailored to your facility</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => {
            let link = '/services';
            if (service.title === 'Fire Detection Systems') link = '/services/fire-detection';
            if (service.title === 'Fire Protection Equipment') link = '/services/fire-protection';
            return (
              <div key={index} className="service-glass-card hover-lift">
                <div className="service-icon-wrapper">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={link} className="service-link">Learn More →</Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ServiceHighlight;
